<app-stream-details
  [deliverableForm]="deliverableForm()"
  [deliverableId]="deliverableId()"
  [deliverableType]="deliverableType()"
  [executionAnalytics]="executionAnalytics()"
  [platformFeature]="platformFeature()"
  [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
/>
